// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  WORKPLAN_FORMAT_WORKPACKAGES,
} from './constants';

export function formatWorkpackages() {
  return {
    type: WORKPLAN_FORMAT_WORKPACKAGES,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case WORKPLAN_FORMAT_WORKPACKAGES:
      return {
        ...state,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/workplan/redux/formatWorkpackages.js